import InvitationList from 'app/scripts/models/collections/invitation-list.coffee';
import { OrganizationInvitation } from 'app/scripts/models/OrganizationInvitation';

class OrganizationInvitationList extends InvitationList {
  static initClass() {
    this.prototype.model = OrganizationInvitation;
  }
}
OrganizationInvitationList.initClass();

export { OrganizationInvitationList };
